import { createContext } from 'react';

const AiTrainingDataContext = createContext();
AiTrainingDataContext.displayName = 'AiTrainingDataContext';

export default AiTrainingDataContext;
